import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : {
        "Content-Type": "application/json",
      };
};

export async function listServices(params = {}, token) {
  const res = await axios.get(`${API}/services`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function listCategories(params = {}, token) {
  const res = await axios.get(`${API}/categories`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getService(serviceId, token) {
  const res = await axios.get(`${API}/services/${serviceId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createService(data, token) {
  const res = await axios.post(`${API}/services`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateService(serviceId, data, token) {
  const res = await axios.put(`${API}/services/${serviceId}`, data, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteService(serviceId, token) {
  await axios.delete(`${API}/services/${serviceId}`, {
    headers: authHeaders(token),
  });
}

export async function getEligibleStaffBulk(serviceIds, token) {
  const res = await axios.post(
    `${API}/services/eligible-staff/bulk`,
    { service_ids: serviceIds },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getEligibleStaffForService(serviceId, params = {}, token) {
  const res = await axios.get(`${API}/services/${serviceId}/eligible-staff`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}
